<h1>
  Stats for {{ serviceLabel | titlecase }} and {{ resourceLabel | titlecase }} from {{ formatDateToTimestamp(fromDate, 'from') | trDateFormat: 'MMM D, y':timezone }} to {{ formatDateToTimestamp(toDate, 'to') | trDateFormat: 'MMM D, y':timezone }}
</h1>

<common-radio-group
  [items]="servicesResourcesRadioItems"
  [(ngModel)]="selectedRadioItem"
  [minButtonWidthPx]="150"
  uncheckedButtonClass="btn-info"
  checkedButtonClass="btn-info"
  groupId="services-and-resources-group"
  width="100%"
></common-radio-group>

<table *ngIf="metrics[selectedRadioItem].length; else noDataAvailable" class="table table-striped tr-table table-bottom-spacer">
  <thead>
  <tr>
    <td [innerText]="nameColumnHeaderValue"></td>
    <td>Guests</td>
    <td>Parties</td>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let metric of metrics[selectedRadioItem]">
    <td [innerText]="getName(metric.id, metric.comboId)"></td>
    <td [innerText]="metric.guests"></td>
    <td [innerText]="metric.parties"></td>
  </tr>
  </tbody>
</table>

<ng-template #noDataAvailable>
  <div class="d-flex flex-row justify-content-center align-items-center">
    <h2 [innerText]="noDataText"></h2>
  </div>
</ng-template>
